import React from 'react'
import { CheckWrapper } from '../../components/CheckDispatch/CheckWrapper'
import { CheckProvider } from '../../components/CheckDispatch/provider/checkProvider'
import { useStyles } from './styles'

interface CheckPageProps {}
/*
 * Copyright 2022-07-26 por Alfonso Moya Ecomsur Holding S.A ©
 * Detalle: Se crea archivo CheckPage por cambio a useReducer + Context
 */

export const CheckPage: React.FC<CheckPageProps> = () => {
  const classes = useStyles()
  return (
    <CheckProvider>
      <div className={classes.flexContainer}>
        <CheckWrapper />
      </div>
    </CheckProvider>
  )
}
